module.exports = __webpack_public_path__ + "img/icon_invertir_orden.ac0e5c1f.svg";